import AssignmentTwoToneIcon from '@material-ui/icons/AssignmentTwoTone'
import AssignmentTurnedInTwoToneIcon from '@material-ui/icons/AssignmentTurnedInTwoTone'
import CheckCircleTwoToneIcon from '@material-ui/icons/CheckCircleTwoTone'
import HourglassFullTwoToneIcon from '@material-ui/icons/HourglassFullTwoTone'

const taxExemptionStatusList = [
  {
    key: 'GATHERING_INFORMATION',
    title: 'Gathering Information',
    icon: AssignmentTwoToneIcon,
    step: 0,
    path: '/questionnaire',
    description: 'Complete Your Questionnaire',
  },
  {
    key: 'PREPARING_ORG_DOCUMENTS',
    title: 'Preparing Organization Documents',
    icon: AssignmentTurnedInTwoToneIcon,
    step: 1,
    path: '/',
    description: '',
  },
  {
    key: 'WAITING_ON_STATE_DEP',
    title: 'Waiting on State Department',
    icon: HourglassFullTwoToneIcon,
    step: 2,
    path: '/',
    description: '',
  },
  {
    key: 'PREPPING_TAX_EXEMPTION',
    title: 'Prepping Tax Exemption Application',
    icon: AssignmentTurnedInTwoToneIcon,
    step: 3,
    path: '/',
    description: '',
  },
  {
    key: 'WAITING_ON_IRS',
    title: 'Waiting on IRS',
    icon: HourglassFullTwoToneIcon,
    step: 4,
    path: '/',
    description: '',
  },
  {
    key: 'TAX_EXEMPTION_SUCCESSFUL',
    title: '501(c)(3) Tax Exemption Successful!',
    icon: CheckCircleTwoToneIcon,
    step: 5,
    path: '/',
    description: 'celebrate',
  },
]

export default taxExemptionStatusList
